module.exports = function(app) {
	'use strict';

	app.directive('eprSubscriberInfo', function () {
		return {
			template: require('directives/employee/eprSubscriberInfo.html'),
			restrict: 'A',
			replace: true,

			scope: {
				employee: '=eprSubscriberInfo',
				editMode: '=?'
			},

			controller: ['$scope', 'services', 'options', 'addFlowCommander', 'sessionData', 'coremetrics', '$state','employee', '$rootScope','modal','storage',
				function($scope, services, options, addFlowCommander, sessionData, coremetrics, $state, employee, $rootScope, modal, storage) {
					$scope.commander = addFlowCommander;
                    var stpValid = true;
                    $scope.isWY = sessionData.employerInfo.brandName === '6012';
					if ($scope.employee.data && $scope.employee.data.subscriber && $scope.employee.data.subscriber.cobra && $scope.employee.data.subscriber.cobra === undefined) {
						$scope.employee.data.subscriber.cobra = {'value': false};
					}
                    if(sessionData.appConfig && sessionData.appConfig.SEP) {
                        $scope.hasSEP = sessionData.appConfig.SEP.booleanValue;
                            //sessionData.appConfig.SEP.booleanValue;

                    }
                    else {
                        $scope.hasSEP = false;
                    }
                    $scope.outSideOpen = false;
                    if($scope.hasSEP) {
                        services.eprsvc.lifeEventRules().checkOpenEnrollment().then(
                            function (response) {
                                if (response) {
                                    $scope.outSideOpen = response;
                                }
                            });
                        services.eprsvc.lifeEventRules().getLifeEventRules().then(
                            function (response) {
                                if (response && response.data && response.data.payload) {
                                    $scope.lifeEventValues = response.data.payload;
                                }
                            }
                        );
                    }
					if ($scope.editMode == false && $state.current.name == 'employee.find.review') {
						coremetrics.pageviewTag("EMPLOYERS:ENROLLMENT:VIEW SUBSCRIBER SUMMARY", "EMPLOYERS:ENROLLMENT");
					}
                    if ($scope.editMode == true && $state.current.name == 'employee.find.review') {
                        coremetrics.pageviewTag("EMPLOYERS:ENROLLMENT:EDIT EMPLOYEE", "EMPLOYERS:ENROLLMENT");
                    }

                    $scope.today = new Date();
					$scope.dt1900 = new Date(1900, 0, 1);
					$scope.dt2500 = new Date(2500, 1, 1);
                    $scope.todayPlus1 = new Date();
                    $scope.todayPlus1.setDate($scope.todayPlus1.getDate()+1);
                    $scope.todayPlus2 = new Date();
                    $scope.todayPlus2.setDate($scope.todayPlus2.getDate()+1);

					$scope.arrCutOffDates = {
						'dtHireMin': $scope.dt1900,
						'dtHireMax': $scope.dt2500,
						'dtCovMin': $scope.dt1900,
						'dtCovMax': $scope.dt2500,
						'dtBirthMin': $scope.dt1900,                               // Just a floor value
						'dtBirthMax': $scope.today
					};

                    //custom message
                    $scope.strHireDateMaxViolation = 'Please enter valid Hire Date';
                    $scope.strHireDateMinViolation = 'Please enter valid Hire Date';
                    $scope.strCovDateMaxViolation = 'Please enter valid Cov Date';
                    $scope.strCovDateMinViolation = 'Please enter valid Cov Date';
                    $scope.strDOBMaxViolation = 'Please enter valid Date of Birth';
                    $scope.strDOBMinViolation = 'Please enter valid Date of Birth';



					$scope.birthCalOptions = { dateMax: Number($scope.todayPlus1) };

// hide or show cobra
					$scope.asoValue = sessionData.entitlements.clientQualifiers.aso; //false;
					$scope.employerName = sessionData.employerInfo.planAdministrator.company;
                    $scope.isChrome = ((navigator.userAgent.toLowerCase().indexOf('chrome') > -1) &&(navigator.vendor.toLowerCase().indexOf("google") > -1));
                    $scope.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
					// These values should probably live somewhere that isn't within this app
					//// I don't think the options should ever be attached to the addFlowCommander
					//// As an alternative, you could put them directly on $scope or put options on $scope
					$scope.commander.policyHolderRelationOptions = options.policyHolderRelations;
					$scope.commander.policyHolderEmploymentStatus = options.policyHolderEmploymentStatuses;
					$scope.commander.custodyOptions = options.custodyTypes;
					$scope.states = options.statesOfUSA;
					$scope.suffixes = options.suffixes;

					services.eprsvc.enrollmentsPrefixesAndRelationships().fetch().then(
						function(response) {

                            $scope.relationships = response.relationships;
							$scope.prefixes = response.prefixes;
						}
					);
                    $scope.$watch('employee.data.subscriber.cobra.value', function(newValue) {
                            storage.set('isCobra',newValue);
                    });



					$scope.$watch('employee.data.subscriber.hireDate', function(newValue) {
						if (newValue instanceof Date) {
							$scope.arrCutOffDates.dtCovMin = new Date(newValue);
							$scope.arrCutOffDates.dtCovMin.setDate(newValue.getDate()-1);
                            var d1 =  angular.copy($scope.arrCutOffDates.dtCovMin) ;
                            d1.setDate(d1.getDate()+1);
                           // $scope.strCovDateMinViolation = '1 Hire Date cannot be greater than coverage effective date ' + d1.toLocaleDateString();
                            $scope.strCovDateMinViolation = 'Hire Date cannot be greater than coverage effective date';

                            $scope.arrCutOffDates.dtBirthMax = new Date(newValue);
							$scope.arrCutOffDates.dtBirthMax.setDate(newValue.getDate()+1);
                            var d2 =  angular.copy($scope.arrCutOffDates.dtBirthMax) ;
                            d2.setDate(d2.getDate() -1);
                           // $scope.strDOBMaxViolation = '2 The hire date cannot be earlier than the birth date. Please enter a valid hire date ' + d2.toLocaleDateString() ;
                            $scope.strDOBMaxViolation = 'Hire date cannot be earlier than the birth date. Please enter a valid hire date ';
						}
                        else {
                            if ($scope.employee.data.subscriber.birthDate instanceof Date) {
                                $scope.arrCutOffDates.dtCovMin = new Date($scope.employee.data.subscriber.birthDate);
                                $scope.arrCutOffDates.dtCovMin.setDate($scope.employee.data.subscriber.birthDate.getDate() - 1);
                                var d3 =  angular.copy($scope.arrCutOffDates.dtCovMin) ;
                                d3.setDate(d3.getDate()+1);
                                //$scope.strCovDateMinViolation = '3 Coverage effective date is before their date of birth. Please enter a valid date of birth. ' + d3.toLocaleDateString();
                                $scope.strCovDateMinViolation = 'Member effective date is before their date of birth. Please enter a valid date of birth. ';
                            } else {
                                $scope.arrCutOffDates.dtCovMin = $scope.dt1900;
                                var d4 =  angular.copy($scope.arrCutOffDates.dtBirthMax) ;
                                d4.setDate(d4.getDate()-2);
                               // $scope.strCovDateMinViolation = '4 Coverage Date has to be more than 1/1/1900';
                                $scope.strCovDateMinViolation = 'Coverage Date has to be more than 1/1/1900';
                            }

                            if ($scope.employee.data.subscriber.globalCoverageEffectiveDate instanceof Date) {
                                $scope.arrCutOffDates.dtBirthMax = new Date($scope.employee.data.subscriber.globalCoverageEffectiveDate);
                                $scope.arrCutOffDates.dtBirthMax.setDate($scope.employee.data.subscriber.globalCoverageEffectiveDate.getDate() + 1);
                                var d5 =  angular.copy($scope.arrCutOffDates.dtBirthMax) ;
                                d5.setDate(d5.getDate());
                               // $scope.strDOBMaxViolation = '5 Date of birth has be less than Coverage effective date ' + d5.toLocaleDateString() ;
                                $scope.strDOBMaxViolation = 'Date of birth has to be less than Coverage effective date';
                            }
                            else {
                                $scope.arrCutOffDates.dtHireMax = $scope.dt2500;
                               // debugger ;

                                var d6 =  angular.copy($scope.arrCutOffDates.dtBirthMax) ;
                                d6.setDate(d6.getDate()-2);
                               // $scope.strDOBMaxViolation = '6 Please enter valid Date of Birth  ' + $scope.today.toLocaleDateString() ;
                                $scope.strDOBMaxViolation = 'Please enter valid Date of Birth';
                                }

                        }
						if ($scope.arrCutOffDates.dtBirthMax > $scope.todayPlus1) {
							$scope.arrCutOffDates.dtBirthMax = $scope.todayPlus1;
                            var d7 =  angular.copy($scope.arrCutOffDates.dtBirthMax) ;
                            d7.setDate(d7.getDate());
                            $scope.strDOBMaxViolation = 'Please enter valid Date of Birth' ;
						}
					});
                    $scope.$watch('employee.data.subscriber.birthDate', function(newValue) {

                        if (newValue instanceof Date) {
                            stpValid = false;
                            $scope.arrCutOffDates.dtHireMin = new Date(newValue);
                            $scope.arrCutOffDates.dtHireMin.setDate(newValue.getDate()-1);
                            var dc =  angular.copy($scope.arrCutOffDates.dtHireMin) ;
                            dc.setDate(dc.getDate()+1);
                            // $scope.strHireDateMinViolation = 'c The hire date cannot be earlier than the birth date of ' + dc.toLocaleDateString() ;
                            $scope.strHireDateMinViolation = 'Hire date cannot be earlier than the birth date';

                            if ($scope.employee.data.subscriber.hireDate instanceof Date) {
                                $scope.arrCutOffDates.dtCovMin = new Date($scope.employee.data.subscriber.hireDate);
                                $scope.arrCutOffDates.dtCovMin.setDate($scope.employee.data.subscriber.hireDate.getDate()-1);
                                var dd =  angular.copy($scope.arrCutOffDates.dtCovMin) ;
                                dd.setDate(dd.getDate()-0);
                                // $scope.strCovDateMinViolation = 'd Hire Date cannot be greater than coverage effective date ' + dd.toLocaleDateString();
                                $scope.strCovDateMinViolation = 'Hire Date cannot be greater than coverage effective date ';
                            }
                            else {
                                $scope.arrCutOffDates.dtCovMin = new Date(newValue);
                                $scope.arrCutOffDates.dtCovMin.setDate(newValue.getDate() - 1);
                                var de =  angular.copy($scope.arrCutOffDates.dtCovMin) ;
                                de.setDate(de.getDate()+1);
                                //$scope.strCovDateMinViolation = 'e Member effective date is before their date of birth of ' + de.toLocaleDateString();
                                $scope.strCovDateMinViolation = 'Member effective date is before their date of birth ';

                            }
                        }
                    });

					$scope.$watch('employee.data.globalCoverageEffectiveDate', function(newValue, oldvalue) {

						if (newValue instanceof Date) {
                            if(newValue !== oldvalue) {
                                if ($scope.asoValue) {
                                    var enteredDate = newValue;
                                    var today = new Date();
                                    var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
                                    var firstDayOfMonthMinus3Y = new Date(firstDayOfMonth.getFullYear() - 3, firstDayOfMonth.getMonth(), 1);
                                    var firstDayOfMonthMinus6Mo = new Date(firstDayOfMonth.getFullYear(), firstDayOfMonth.getMonth() - 6, 1);
                                    if ((enteredDate < firstDayOfMonthMinus6Mo) && (enteredDate > firstDayOfMonthMinus3Y ) && stpValid) {
                                        modal.open({
                                                       template: require('pages/employee/modals/asoEffectiveDateModal.html'),
                                                       scope: $scope
                                                   });
                                    }
                                    stpValid = true;
                                }
                            }

							$scope.arrCutOffDates.dtHireMax = new Date(newValue);
							$scope.arrCutOffDates.dtHireMax.setDate(newValue.getDate()+1);
                            var d8 =  angular.copy($scope.arrCutOffDates.dtHireMax) ;
                            d8.setDate(d8.getDate()-1);
                            //$scope.strHireDateMaxViolation = '8 Hire Date cannot be greater than coverage effective date ' + d8.toLocaleDateString() ;
                            $scope.strHireDateMaxViolation = 'Hire Date cannot be greater than coverage effective date ';
						}

                        if ($scope.employee.data.subscriber.hireDate instanceof Date) {
                            $scope.arrCutOffDates.dtBirthMax = new Date($scope.employee.data.subscriber.hireDate);
                            $scope.arrCutOffDates.dtBirthMax.setDate($scope.employee.data.subscriber.hireDate.getDate()+1);
                            var d9 =  angular.copy($scope.arrCutOffDates.dtBirthMax) ;
                            d9.setDate(d9.getDate()-1);
                           // $scope.strDOBMaxViolation = '9 Date of birth has be less than Hire Date ' + d9.toLocaleDateString() ;
                            $scope.strDOBMaxViolation = 'Date of birth has to be less than Hire Date';
                        }
                        else {
                            if (newValue instanceof Date) {
                                $scope.arrCutOffDates.dtBirthMax = new Date(newValue);
                                $scope.arrCutOffDates.dtBirthMax.setDate(newValue.getDate() - 1);
                                var da =  angular.copy($scope.arrCutOffDates.dtBirthMax) ;
                                da.setDate(da.getDate()+1);
                               // $scope.strDOBMaxViolation = 'a Date of birth has be less than coverage effective date ' + da.toLocaleDateString();
                                $scope.strDOBMaxViolation = 'Date of birth has to be less than coverage effective date';
                            }
                            else
                            {
                                $scope.arrCutOffDates.dtBirthMax = $scope.todayPlus1;
                                var db =  angular.copy($scope.arrCutOffDates.dtBirthMax) ;
                                db.setDate(db.getDate()-1);

                                //$scope.strDOBMaxViolation = 'b Please enter valid Date of Birth  ' + db.toLocaleDateString() ;
                                $scope.strDOBMaxViolation = 'Please enter valid Date of Birth';
                            }
                        }
                        // if (newValue instanceof Date && $scope.hasSEP){
                        //     if ($scope.employee.data.subscriber.eventCode && $scope.employee.data.subscriber.eventDate) {
                        //         var newArray = [];
                        //         newArray = $scope.lifeEventValues.filter(function (el) {
                        //             return el.lifeEventId === $scope.employee.data.subscriber.eventCode;
                        //         });
                        //         $scope.arrCutOffDates.dtCovMin = new Date($scope.employee.data.subscriber.eventDate.getFullYear(), $scope.employee.data.subscriber.eventDate.getMonth(), $scope.employee.data.subscriber.eventDate.getDate() - parseInt(newArray[0].beforeDays));
                        //
                        //     $scope.arrCutOffDates.dtCovMax = new Date($scope.employee.data.subscriber.eventDate.getFullYear(), $scope.employee.data.subscriber.eventDate.getMonth(), $scope.employee.data.subscriber.eventDate.getDate() + parseInt(newArray[0].afterDays));
                        //         if(newValue < $scope.arrCutOffDates.dtCovMin){
                        //             console.log("hello anna");
                        //             $scope.arrCutOffDates.dtCovMin.setDate($scope.arrCutOffDates.dtCovMin.getDate()+1);
                        //             $scope.strCovDateMinViolation = 'The Life Event Date given is outside the allowable Special Enrollment Period.  To proceed, please verify the date entered or contact your BCBSWY Agent at BCBSWY.com/insurance.';
                        //         }
                        //         else if(newValue > $scope.arrCutOffDates.dtCovMax){
                        //             $scope.arrCutOffDates.dtCovMax.setDate($scope.arrCutOffDates.dtCovMax.getDate()-1);
                        //             $scope.strCovDateMaxViolation = 'The Life Event Date given is outside the allowable Special Enrollment Period.  To proceed, please verify the date entered or contact your BCBSWY Agent at BCBSWY.com/insurance.';
                        //         }
                        //
                        //     }
                        // }
					});


                   // if($scope.hasSEP) {
                        // $scope.$watch('employee.data.subscriber.eventDate', function (n) {
                        //     if (n instanceof Date) {
                        //         if ($scope.employee.data.subscriber.eventCode) {
                        //             var newArray = [];
                        //             newArray = $scope.lifeEventValues.filter(function (el) {
                        //                 return el.lifeEventId === $scope.employee.data.subscriber.eventCode;
                        //             });
                        //             $scope.arrCutOffDates.dtCovMin = new Date($scope.employee.data.subscriber.eventDate.getFullYear(), $scope.employee.data.subscriber.eventDate.getMonth(), $scope.employee.data.subscriber.eventDate.getDate() - parseInt(newArray[0].beforeDays));
                        //             $scope.arrCutOffDates.dtCovMax = new Date($scope.employee.data.subscriber.eventDate.getFullYear(), $scope.employee.data.subscriber.eventDate.getMonth(), $scope.employee.data.subscriber.eventDate.getDate() + parseInt(newArray[0].afterDays));
                        //             if ($scope.employee.data.globalCoverageEffectiveDate) {
                        //                 if ($scope.employee.data.globalCoverageEffectiveDate < $scope.arrCutOffDates.dtCovMin) {
                        //                     $scope.strCovDateMinViolation = 'The Life Event Date given is outside the allowable Special Enrollment Period.  To proceed, please verify the date entered or contact your BCBSWY Agent at BCBSWY.com/insurance.';
                        //                 }
                        //                 else if ($scope.employee.data.globalCoverageEffectiveDate > $scope.arrCutOffDates.dtCovMax) {
                        //                     $scope.strCovDateMaxViolation = 'The Life Event Date given is outside the allowable Special Enrollment Period.  To proceed, please verify the date entered or contact your BCBSWY Agent at BCBSWY.com/insurance.';
                        //                 }
                        //             }
                        //         }
                        //     }
                        // }, true);
                        // $scope.$watch('employee.data.subscriber.eventCode', function (n) {
                        //     if ($scope.employee.data.subscriber.eventDate instanceof Date) {
                        //         var newArray = [];
                        //         newArray = $scope.lifeEventValues.filter(function (el) {
                        //             return el.lifeEventId === $scope.employee.data.subscriber.eventCode;
                        //         });
                        //         $scope.arrCutOffDates.dtCovMin = new Date($scope.employee.data.subscriber.eventDate.getFullYear(), $scope.employee.data.subscriber.eventDate.getMonth(), $scope.employee.data.subscriber.eventDate.getDate() - parseInt(newArray[0].beforeDays));
                        //         $scope.arrCutOffDates.dtCovMax = new Date($scope.employee.data.subscriber.eventDate.getFullYear(), $scope.employee.data.subscriber.eventDate.getMonth(), $scope.employee.data.subscriber.eventDate.getDate() + parseInt(newArray[0].afterDays));
                        //         if ($scope.employee.data.globalCoverageEffectiveDate) {
                        //             if ($scope.employee.data.globalCoverageEffectiveDate < $scope.arrCutOffDates.dtCovMin) {
                        //                 $scope.strCovDateMinViolation = 'The Life Event Date given is outside the allowable Special Enrollment Period.  To proceed, please verify the date entered or contact your BCBSWY Agent at BCBSWY.com/insurance.';
                        //             }
                        //             else if ($scope.employee.data.globalCoverageEffectiveDate > $scope.arrCutOffDates.dtCovMax) {
                        //                 $scope.strCovDateMaxViolation = 'The Life Event Date given is outside the allowable Special Enrollment Period.  To proceed, please verify the date entered or contact your BCBSWY Agent at BCBSWY.com/insurance.';
                        //             }
                        //         }
                        //     }
                        //
                        // }, true);
                   // }
				}
			]
		};
	});
};
